import React from "react";
import { IconPresentationProps } from "@insite/mobius/Icon";

const GVUser: React.FC<IconPresentationProps> = props => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 8.65625C12.3125 8.65625 14.1875 6.84375 14.1875 4.59375C14.1875 2.34375 12.3125 0.53125 10 0.53125C7.6875 0.53125 5.8125 2.34375 5.8125 4.59375C5.8125 6.84375 7.6875 8.65625 10 8.65625ZM10 1.96875C11.5312 1.96875 12.7813 3.15625 12.7813 4.625C12.7813 6.09375 11.5312 7.28125 10 7.28125C8.46875 7.28125 7.21875 6.09375 7.21875 4.625C7.21875 3.15625 8.46875 1.96875 10 1.96875Z" fill="#1C1917"/>
            <path d="M12.0312 10.0625H7.96875C4.625 10.0625 1.90625 12.8125 1.90625 16.1563V18.75C1.90625 19.125 2.21875 19.4688 2.625 19.4688C3.03125 19.4688 3.34375 19.1563 3.34375 18.75V16.1563C3.34375 13.5938 5.4375 11.4688 8.03125 11.4688H12.0625C14.625 11.4688 16.75 13.5625 16.75 16.1563V18.75C16.75 19.125 17.0625 19.4688 17.4688 19.4688C17.875 19.4688 18.1875 19.1563 18.1875 18.75V16.1563C18.0938 12.8125 15.375 10.0625 12.0312 10.0625Z" fill="#1C1917"/>
        </svg>
    );
};

export default React.memo(GVUser);

